import React from 'react';

import { FilterContext } from '../../Context/FilterContext';
import Button from '../../Form/Button/Button';
import SimpleLink from '../../Form/SimpleLink/SimpleLink';
import { AccountOnlineAnalysis, AccountSkinAnalysis } from '../../MyLom/Account/EditAccount/Types';
import { SkinAnalysisSectionIdentifier } from '../../Types';
import { formatDate, isSkinAnalysis } from '../../Utils';
import { PhoneInfo } from './PhoneInfo/PhoneInfo';
import { getAnalysisLabel } from './SkinAnalysisTable';

import '../SkinAnalysisSection.scss';

interface Props {
    skinAnalysisSectionIdentifier: SkinAnalysisSectionIdentifier;
    skinAnalyses: Array<AccountSkinAnalysis | AccountOnlineAnalysis>;
    useReactRouterLink: boolean;
    toggleVisibility?: () => void;
}

const SkinAnalysisTableMobile: React.FunctionComponent<Props> = (props) => {
    const { activeSkinAnalysis, updateActiveSkinanalysis, updateOnlineAnalysis, onlineAnalysis } =
        React.useContext(FilterContext);
    const handleSkinAnalysisClick = (analysis: AccountOnlineAnalysis | AccountSkinAnalysis) => {
        if (isSkinAnalysis(analysis)) {
            if (analysis.id === activeSkinAnalysis) {
                return;
            }
            updateActiveSkinanalysis(analysis.id);
        } else {
            updateOnlineAnalysis(analysis);
        }

        if (props.toggleVisibility && typeof props.toggleVisibility === 'function') {
            props.toggleVisibility();
        }
    };

    return (
        <div className="skin-analysis__table--mobile">
            {props.skinAnalyses.map((analysis) => (
                <div
                    key={analysis.id}
                    className={
                        'skin-analysis__entry' +
                        (activeSkinAnalysis === analysis.id ? ' skin-analysis__entry--active' : '')
                    }
                >
                    {isSkinAnalysis(analysis) ? (
                        <>
                            <div className="skin-analysis__consultant-image">
                                <img src={analysis.consultant.image || ''} />
                            </div>
                        </>
                    ) : null}

                    <div className="skin-analysis__info">
                        {isSkinAnalysis(analysis) ? (
                            <>
                                <strong>
                                    {getAnalysisLabel(analysis)}
                                    {analysis.byPhone ? <PhoneInfo /> : ''}
                                </strong>
                                <small>{formatDate(new Date(analysis.creationDateTime))}</small>
                                {analysis.nextGenMeetingId !== null ? (
                                    <SimpleLink
                                        link={'/mylom/termine/zusammenfassung/' + analysis.nextGenMeetingId}
                                        text="Ergebnisse anzeigen"
                                    />
                                ) : null}
                            </>
                        ) : null}
                    </div>

                    <div className="skin-analysis__button">
                        {!(isSkinAnalysis(analysis) && analysis.nextGenMeetingId) ? (
                            <Button
                                icon={null}
                                primary={activeSkinAnalysis === analysis.id || analysis.id === onlineAnalysis?.id}
                                type="button"
                                value={analysis.id}
                                onClick={() => handleSkinAnalysisClick(analysis)}
                                dataSpacePreserve="wählen"
                            >
                                {activeSkinAnalysis === analysis.id || analysis.id === onlineAnalysis?.id
                                    ? 'aktiv'
                                    : 'wählen'}
                            </Button>
                        ) : null}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SkinAnalysisTableMobile;
